(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/my-receiver-item.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/my-receiver-item.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.MyReceiverItem = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.my_receiver_item(data);
    },
    events: {
      'click .js-remove-support-btn': 'removeSupport',
      'click .js-show-tooltip': 'onShowTooltip'
    },
    tagName: 'div',
    className: '',

    removeSupport: function() {
      svs.ui.loader.show();
      this.model.collection.removeSupport(
        this.model.get('id'),
        this.model.get('longname')
      );
      return false;
    },
    onShowTooltip: function(e) {
      const _dialog = new svs.ui.dialog.Contextual({
        branding: svs.core.data.tenant === 'lb' ? svs.ui.dialog.branding.SPORT : svs.ui.dialog.branding.TUR,
        attachTo: $(e.currentTarget),
        zIndex: svs.core.detect.formfactor.mobile() ? 140 : 160,
        title: ' ',
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text:
              'Din förening finns ej längre med i Gräsroten. Det kan bero på att föreningen upphört, ombildats eller gått ur Gräsroten. Välj gärna en ny förening.'
          }
        ]
      });
      svs.ui.dialog.api.add(_dialog);
      e.stopPropagation();
    }
  });
})(Backbone, _, svs);


 })(window);